<template>
  <!-- Główny kontener filtrów na poziomie widoku kalibracji -->
  <div class="calibration d-flex justify-content-between filters-container">
    <!-- Lista lokalizacji: przekazujemy referencję do store filtrów -->
    <location-list :store="filtersStore" />
    <!-- Komponent wyboru rozdzielczości: bindujemy ten sam store -->
    <resolution-filter :store="filtersStore" v-if="from == 'calibration'"/>
    <!-- Komponent zakresu dat: również używa tego store -->
    <date-range :store="filtersStore" v-if="from == 'calibration' || from == 'calibration-deviation'"/>
  </div>
</template>

<script>
// Import hooka Pinia do korzystania ze store'a filtrów kalibracji
import { useCalibrationFiltersStore } from "@/stores/calibration";
// Import komponentu zakresu dat
import DateRange from "@/components/users/DateRange";
// Import komponentu listy lokalizacji
import LocationList from "@/components/filters/LocationList";
// Import komponentu wyboru rozdzielczości
import ResolutionFilter from "@/components/statistics/ResolutionFilter";

export default {
  name: "FilterActivityList",
  components: {
    LocationList,      // komponent wyboru lokalizacji
    ResolutionFilter,  // komponent wyboru rozdzielczości
    DateRange,         // komponent wyboru zakresu dat
  },
  props: {
    from: {
      type: String,
      default: "", // domyślna wartość daty początkowej
    },
  },
  setup() {
    // Inicjalizujemy store Pinia z filtrami kalibracji
    const filtersStore = useCalibrationFiltersStore();
    // Zwracamy referencję do store, by komponenty potomne mogły się bindować
    return { filtersStore };
  },
};
</script>

<style scoped>
/* Styl nagłówka filtra (kiedy jest użyty element h5) */
.filter h5 {
  margin: 0;
  padding: 10px 20px;
  background-color: white;
  position: relative;
  /* Dodajemy tło z obrazkiem powtarzającym się w osi Y */
  background: white url("../assets/h-filter-bg.png") repeat-y right top;
}

/* Wiersz wewnątrz filtrów ma określoną wysokość i linię tekstu */
.row {
  height: 30px;
  line-height: 25px;
}

/* Ogólne informacje w filtrze: mniejszy font, padding i dolna ramka */
.info {
  font-size: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #bbbbbb;
}

/* Akapit w sekcji info dziedziczy mniejszy font i usuwa margines */
.info p {
  font-size: 12px;
  margin: 0;
}

/* Ikona zwijania/rozwijania: ustawiona absolutnie w prawym rogu */
.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}

/* Klasa .collapsed zmienia tło ikony na rozwinięcie */
.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}
</style>